import { Box, CircularProgress, Typography } from "@mui/material"
import NoRecords from "components/NoRecords";
import { InfoOutlined } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import SubstitutesAvailableList from "./List/SubstitutesAvailableList";

const SubstitutesAvailable = ({ periods, date, availableSubstitutes, boxStyles, innerBoxStyles, coveragePeriods }) => {
    const loading = useSelector(state => state.substitutePortal.substitute.subsLoading);

    const { t } = useTranslation()


    return (
        <Box sx={{ ...boxStyles, flexGrow: 1 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="subtitle1">{t('Available Substitutes')}</Typography>
            </Box>
            {loading ? (
                <Box sx={{ ...innerBoxStyles }}>
                    <CircularProgress size={50} />
                </Box>
            ) : availableSubstitutes?.length > 0 ? (
                <Box sx={{ ...innerBoxStyles, alignItems: "flex-start" }}>
                    <SubstitutesAvailableList date={date} availableSubstitutes={availableSubstitutes} periods={periods} coveragePeriods={coveragePeriods} />
                </Box>
            ) : (
                <Box sx={{ ...innerBoxStyles }}>
                    <NoRecords
                        icon={<InfoOutlined sx={{ fontSize: 50, color: "primary.main" }} />}
                        message="No Avaiable Substitutes"
                    />
                </Box>
            )}
        </Box>
    )
}

export default SubstitutesAvailable